import { addDestroyableEventListener, createElementFromTemplate } from '../../dom';
const TEMPLATE = `
        <div>
            <span class="ag-hidden ag-collapse" aria-hidden="true">
                 <alk-button class="customCollapseButton"
                             fill={ AlkButtonFillEnum.CLEAR }
                             shape={ AlkButtonShapeEnum.SQUARE }>
                    <ion-icon src="assets/icon/md/fnx_md-collapse-all.svg"/>
                 </alk-button>
            </span>
            <span class="ag-hidden ag-expand" aria-hidden="true">
                 <alk-button class="customExpandButton"
                             fill={ AlkButtonFillEnum.CLEAR }
                             shape={ AlkButtonShapeEnum.SQUARE }>
                    <ion-icon src="assets/icon/md/fnx_md-expand-all.svg"/>
                 </alk-button>
            </span>
        </div>
    `;
// eslint-disable-next-line @typescript-eslint/naming-convention
export function AgExpandCollapseHeaderDecorator(base) {
    return class extends base {
        constructor() {
            super(...arguments);
            this.destroyFunctions = [];
            this.isCollapsed = false;
        }
        init(params) {
            super.init(params);
            this.params = params;
            if (Boolean(this.getGui())) {
                this.AddCustomCollapse();
            }
            else {
                throw new Error('GUI element should not be empty.');
            }
        }
        AddCustomCollapse() {
            var _a, _b, _c;
            if (((_c = (_b = (_a = this.params.columnApi) === null || _a === void 0 ? void 0 : _a.columnModel) === null || _b === void 0 ? void 0 : _b.groupDisplayColumns) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                this.setupCollapseOrExpandIcon();
                this.setupCollapseOrExpandListener();
                this.onCollapseStatusChanged();
            }
        }
        HandleExpandOrCollapseEvent() {
            this.isCollapsed ? this.params.api.collapseAll() : this.params.api.expandAll();
            this.isCollapsed = !this.isCollapsed;
            this.onCollapseStatusChanged();
        }
        setupCollapseOrExpandListener() {
            const onCollapseOrExpandHandler = this.HandleExpandOrCollapseEvent.bind(this, this.params);
            const eCollapseButton = this.getGui().querySelector('alk-button.customCollapseButton');
            const eExpandButton = this.getGui().querySelector('alk-button.customExpandButton');
            this.destroyFunctions.push(addDestroyableEventListener(eCollapseButton, 'click', onCollapseOrExpandHandler), addDestroyableEventListener(eExpandButton, 'click', onCollapseOrExpandHandler));
        }
        setupCollapseOrExpandIcon() {
            this.getGui().append(...createElementFromTemplate(TEMPLATE));
        }
        onCollapseStatusChanged() {
            var _a, _b;
            const gui = this.getGui();
            const eCollapse = gui.querySelector('span.ag-collapse');
            const eExpand = gui.querySelector('span.ag-expand');
            !(this.isCollapsed && ((_a = this.params) === null || _a === void 0 ? void 0 : _a.isCollapsible)) ?
                eCollapse.classList.add('ag-hidden') :
                eCollapse.classList.remove('ag-hidden');
            !(!this.isCollapsed && ((_b = this.params) === null || _b === void 0 ? void 0 : _b.isCollapsible)) ?
                eExpand.classList.add('ag-hidden') :
                eExpand.classList.remove('ag-hidden');
        }
        destroy() {
            if (Boolean(this.destroyFunctions)) {
                this.destroyFunctions.forEach((fnc) => fnc());
            }
        }
    };
}
